import { countConsultationsInPeriod, getPackAccess } from './packSystem';

const MAX_SUPPORTED_FOLLOWUP_ORDINAL = 6;

function stableJsonValue(value) {
  if (Array.isArray(value)) return value.map(stableJsonValue);
  if (value && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = stableJsonValue(value[key]);
        return result;
      }, {});
  }
  return value;
}

export function resolveFollowupVersionOrdinal({
  journeyState,
  packStartedAt,
  packStartedAtConfirmed,
  packType,
  versions = [],
}) {
  const access = getPackAccess(packType);
  if (!access.known || !access.continuousFollowup || packStartedAtConfirmed !== true) {
    throw new Error('La période de suivi doit être confirmée avant de créer une version.');
  }
  const periodStartMs = Date.parse(packStartedAt || '');
  if (!Number.isFinite(periodStartMs)) {
    throw new Error('Le début de la période de suivi est introuvable.');
  }
  const ordinal = countConsultationsInPeriod(
    journeyState?.consultations_log,
    packStartedAt,
  );
  if (!Number.isInteger(ordinal)
      || ordinal < 1
      || ordinal > access.includedFollowupConsultations
      || ordinal > MAX_SUPPORTED_FOLLOWUP_ORDINAL) {
    throw new Error('Aucun rendez-vous de suivi disponible pour cette nouvelle version.');
  }
  const currentPeriodVersions = versions.filter((version) => {
    const isFollowup = version?.isFollowup === true || version?.is_followup === true;
    if (!isFollowup) return false;
    const createdMs = Date.parse(
      version?.createdAt || version?.created_at || version?.date || '',
    );
    if (!Number.isFinite(createdMs)) {
      throw new Error('Une version de suivi sans date fiable empêche de déterminer la période.');
    }
    return createdMs >= periodStartMs;
  });
  const existingVersion = currentPeriodVersions.find((version) => Number(
    version?.followupWeek
    ?? version?.followupData?._followupWeek
    ?? version?.followup_data?._followupWeek,
  ) === ordinal) || null;
  return { ordinal, existingVersion, access };
}

export async function loadCanonicalFollowupOrdinal(
  clientId,
  versions,
  { journeyStateOverride = null, db } = {},
) {
  if (!db?.from) throw new Error('Cloud indisponible : période de suivi non confirmée.');
  const { data, error } = await db
    .from('clients')
    .select('journey_state, pack_started_at, pack_started_at_confirmed, pack_type')
    .eq('id', clientId)
    .maybeSingle();
  if (error || !data) {
    throw new Error(error?.message || 'La période de suivi exacte est introuvable.');
  }
  if (journeyStateOverride) {
    const canonicalLog = JSON.stringify(stableJsonValue(
      data.journey_state?.consultations_log || [],
    ));
    const loggedLog = JSON.stringify(stableJsonValue(
      journeyStateOverride?.consultations_log || [],
    ));
    if (canonicalLog !== loggedLog) {
      throw new Error('Le journal des rendez-vous a changé dans un autre onglet. Recharge la fiche.');
    }
  }
  return resolveFollowupVersionOrdinal({
    journeyState: data.journey_state,
    packStartedAt: data.pack_started_at,
    packStartedAtConfirmed: data.pack_started_at_confirmed,
    packType: data.pack_type,
    versions,
  });
}
